export const getSkeletonNoneTmpl = () => `
  <div class="component-skeleton-sub">
    <span class="hide-txt" aria-live="assertive"></span>
  </div>
`
export const getSkeletonDefaultTmpl = () => `
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt"></span>
  <div class="skeleton-loader" aria-hidden="true">
    <div class="loader-item"></div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonMainTmpl1 = () => `
<div class="component-skeleton-sub bg-lightgray">
  <!--skeletonSource-->
  <span class="hide-txt" aria-live="assertive"></span>
  <div class="skeleton-main-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group my-header-group">
      <div class="home-header-col">
        <a class="btn-logo-kbank" href="#none">
          <span class="hide-txt">Kbank</span>
          <!-- <i class="ico-main-ci" aria-hidden="true"></i> FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 삭제 -->
          <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
          <i class="ico-main-ci" aria-hidden="true"></i>
          <svg class="ico-main-ci" viewBox="0 0 350 87" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M112.229 23.7687C106.183 23.7 100.338 25.9434 95.8912 30.0402L94.4156 31.4104V0H77.709V53.677C77.709 73.7037 89.6724 86.1678 108.935 86.1678C128.198 86.1678 141.478 72.9923 141.478 55.0209C141.478 37.0495 129.146 23.7687 112.229 23.7687ZM109.594 70.8843C106.467 70.8843 103.41 69.9569 100.81 68.2197C98.2098 66.4824 96.1833 64.0131 94.9866 61.1241C93.79 58.2351 93.4769 55.0561 94.0869 51.9891C94.697 48.9222 96.2028 46.105 98.4139 43.8939C100.625 41.6827 103.442 40.1768 106.509 39.5668C109.576 38.9567 112.755 39.2698 115.644 40.4665C118.533 41.6632 121.002 43.6897 122.74 46.2897C124.477 48.8898 125.404 51.9466 125.404 55.0737C125.404 59.2669 123.739 63.2883 120.774 66.2534C117.808 69.2184 113.787 70.8843 109.594 70.8843Z" fill="#120063"/>
            <path d="M49.9088 0L16.891 38.3144V0H0V84.1915H16.891V46.1933L50.5939 84.1915H72.3072L35.0205 42.0825L71.2794 0H49.9088Z" fill="#120063"/>
            <path d="M349.335 25.7449H330.732L309.361 50.9892V0H292.654V84.1915H309.361V58.9472L330.732 84.1915H349.335L324.592 54.9682L349.335 25.7449Z" fill="#120063"/>
            <path d="M259.926 23.7686C256.248 23.6625 252.589 24.3381 249.191 25.7508C245.794 27.1635 242.734 29.2811 240.216 31.9637V25.7186H224.115V84.1388H240.795V52.3858C240.658 50.6637 240.879 48.9319 241.444 47.2994C242.009 45.6669 242.905 44.169 244.077 42.8999C245.249 41.6308 246.671 40.618 248.254 39.9253C249.836 39.2327 251.545 38.8751 253.273 38.8751C255 38.8751 256.709 39.2327 258.291 39.9253C259.874 40.618 261.296 41.6308 262.468 42.8999C263.64 44.169 264.537 45.6669 265.101 47.2994C265.666 48.9319 265.887 50.6637 265.75 52.3858V84.1915H282.43V47.3001C282.43 33.6239 272.522 23.7686 259.926 23.7686Z" fill="#120063"/>
            <path d="M178.829 24C160.199 24 146.654 37.1755 146.654 55.2523C146.654 73.329 159.118 86.3992 176.299 86.3992C179.899 86.387 183.453 85.5801 186.705 84.0359C189.957 82.4917 192.829 80.2483 195.114 77.4661L196.062 76.1486V84.4228H211.241V55.2523C211.241 37.1491 197.617 24 178.829 24ZM179.33 71.1156C176.202 71.1156 173.146 70.1883 170.546 68.451C167.946 66.7137 165.919 64.2444 164.722 61.3554C163.526 58.4664 163.213 55.2874 163.823 52.2205C164.433 49.1535 165.939 46.3364 168.15 44.1252C170.361 41.9141 173.178 40.4082 176.245 39.7981C179.312 39.1881 182.491 39.5012 185.38 40.6978C188.269 41.8945 190.738 43.921 192.476 46.5211C194.213 49.1211 195.14 52.178 195.14 55.305C195.14 59.4982 193.474 63.5197 190.509 66.4847C187.544 69.4498 183.523 71.1156 179.33 71.1156Z" fill="#120063"/>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 --> 
        </a>
      </div>
      <div class="home-header-col">
        <a class="btn-main-benefit" href="#none">
          <span class="hide-txt">혜택</span>
          <span class="svg-main-benefit">
            <span class="box">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="28" height="28" viewBox="0 0 32 32">
                <defs>
                  <path id="a" d="M0 0h32v32H0z" />
                </defs>
                <g fill="none" fill-rule="evenodd">
                  <mask id="b" fill="#fff">
                    <use xlink:href="#a" />
                  </mask>
                  <g mask="url(#b)">
                    <g stroke="#0F0060" stroke-width="2" transform="translate(4.833 4.2)">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M7.417 0c.918 0 1.707.57 2.057 1.388l1.693 3.279h-3.75c-1.243 0-2.25-1.045-2.25-2.334C5.167 1.045 6.174 0 7.417 0zm7.5 0c-.918 0-1.708.57-2.058 1.388l-1.692 3.279h3.75c1.242 0 2.25-1.045 2.25-2.334 0-1.288-1.008-2.333-2.25-2.333z" />
                      <rect width="21.67" height="19" x=".33" y="4.97" rx="2" />
                      <path stroke-linecap="round" stroke-linejoin="round" d="M11.33 5.47v17.5m-10-12.5l19.84.33" />
                    </g>
                  </g>
                </g>
              </svg>
            </span>
            <span class="money">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 19 19">
                <g fill="none" fill-rule="evenodd">
                  <circle cx="9.5" cy="9.5" r="8.5" fill="#FFF" stroke="#0F0060" stroke-width="2" />
                  <circle cx="9.5" cy="9.5" r="7.5" fill="#C8F03E" style="mix-blend-mode:multiply" />
                  <path stroke="#0F0060" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.8" d="M6.071 7l1.696 5 1.725-5 1.593 5 1.844-5M5 9.31h1.714m5.572 0H14" />
                </g>
              </svg>
            </span>
          </span>
        </a>
      </div>
    </div>
    <div class="skeleton-item02-group">
      <div class="skeleton-item02"></div>
      <div class="skeleton-item02"></div>
    </div>
    <div class="skeleton-item03"></div>
    <div class="skeleton-item04"></div>

    <div class="component-btn fixed-bottom home-tab-menu new-home">
      <div class="btn-group">
        <a class="btn-home-tab1 on" href="#none">
          <div class="btn-ico-item">  <!-- 23-01-26 : btn-ico-item 클래스 태그 안으로 변경 tab1 ~ tab4 -->
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_395_18277)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8747 4.70508L25.5928 10.7532C26.0291 11.0718 26.2864 11.5759 26.2864 12.1117V24.6624C26.2864 25.5956 25.5203 26.3521 24.5752 26.3521H20.3856C19.8673 26.3521 19.4465 25.933 19.4445 25.4147L19.4415 24.6624V22.5119C19.4415 21.3666 18.2923 20.4382 16.8747 20.4382C15.457 20.4382 14.3078 21.3666 14.3078 22.5119V24.6624L14.3089 25.4096C14.3096 25.9294 13.8888 26.3514 13.369 26.3521L13.3677 26.3521H9.17412C8.22903 26.3521 7.46289 25.5956 7.46289 24.6624V12.1117C7.46289 11.5759 7.72026 11.0718 8.15652 10.7532L16.8747 4.70508Z" fill="#141414" stroke="#0F0060" stroke-width="2"/>
              </g>
              <defs>
              <clipPath id="clip0_395_18277">
              <rect width="32" height="32" fill="white" transform="translate(0.875)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>홈</em>
          </div>
        </a>
        <a class="btn-home-tab2" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32306)">
                <path d="M21.3308 5.64844H11.919C8.80025 5.64844 6.27197 8.17671 6.27197 11.2955V20.7073C6.27197 23.826 8.80025 26.3543 11.919 26.3543H21.3308C24.4496 26.3543 26.9779 23.826 26.9779 20.7073V11.2955C26.9779 8.17671 24.4496 5.64844 21.3308 5.64844Z" stroke="#141414" stroke-width="2"/>
                <path d="M17.5659 11.2947C17.5659 10.7749 17.1446 10.3535 16.6248 10.3535C16.105 10.3535 15.6836 10.7749 15.6836 11.2947V20.7065C15.6836 21.2263 16.105 21.6476 16.6248 21.6476C17.1446 21.6476 17.5659 21.2263 17.5659 20.7065V11.2947Z" fill="#141414"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.978 16.0002C10.978 15.4804 11.3994 15.0591 11.9192 15.0591H21.331C21.8508 15.0591 22.2721 15.4804 22.2721 16.0002C22.2721 16.52 21.8508 16.9414 21.331 16.9414H11.9192C11.3994 16.9414 10.978 16.52 10.978 16.0002Z" fill="#141414"/>
                </g>
                <defs>
                <clipPath id="clip0_1851_32306">
                <rect width="32" height="32" fill="white" transform="translate(0.625)"/>
                </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>상품</em>
          </div>
        </a>
        <a class="btn-home-tab3" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32283)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3789 21.7526C25.248 21.839 25.0937 21.8839 24.9365 21.8811H7.75719C7.59703 21.8877 7.4386 21.8446 7.30391 21.7579C7.16907 21.6711 7.06454 21.5449 7.00438 21.3965C6.94548 21.2575 6.93048 21.1038 6.96173 20.9561C6.99282 20.8084 7.06845 20.6737 7.1786 20.5703L8.46654 19.2965C9.37761 18.4022 9.89104 17.1799 9.89136 15.9042V12.0645C9.89136 9.77164 11.1165 7.65261 13.1051 6.50631C15.0938 5.35988 17.5438 5.35988 19.5326 6.50631C21.5212 7.65273 22.7463 9.77164 22.7463 12.0645V15.9042C22.7468 17.1799 23.26 18.4022 24.1711 19.2965L25.4591 20.5703C25.5755 20.6693 25.6584 20.802 25.6962 20.9499C25.7341 21.0978 25.7251 21.2539 25.6706 21.3966C25.6117 21.5419 25.51 21.666 25.3789 21.7526Z" stroke="#141414" stroke-width="2"/>
              <path d="M12.3652 23.6836C12.3652 25.6762 14.1851 27.2914 16.43 27.2914C18.6749 27.2914 20.4947 25.6762 20.4947 23.6836" stroke="#141414" stroke-width="2"/>
              </g>
              <defs>
              <clipPath id="clip0_1851_32283">
              <rect width="32" height="32" fill="white" transform="translate(0.375)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>알림</em>
          </div>
        </a>
        <a class="btn-home-tab4" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32338)">
              <path d="M20.8308 5.64648H11.419C8.30025 5.64648 5.77197 8.17476 5.77197 11.2935V20.7053C5.77197 23.8241 8.30025 26.3524 11.419 26.3524H20.8308C23.9496 26.3524 26.4779 23.8241 26.4779 20.7053V11.2935C26.4779 8.17476 23.9496 5.64648 20.8308 5.64648Z" stroke="#141414" stroke-width="2"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 11.2952C10.478 10.7754 10.8994 10.354 11.4192 10.354H20.831C21.3508 10.354 21.7721 10.7754 21.7721 11.2952C21.7721 11.8149 21.3508 12.2363 20.831 12.2363H11.4192C10.8994 12.2363 10.478 11.8149 10.478 11.2952Z" fill="#141414"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 16.0002C10.478 15.4804 10.8994 15.0591 11.4192 15.0591H18.9486C19.4684 15.0591 19.8898 15.4804 19.8898 16.0002C19.8898 16.52 19.4684 16.9414 18.9486 16.9414H11.4192C10.8994 16.9414 10.478 16.52 10.478 16.0002Z" fill="#141414"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 20.7073C10.478 20.1875 10.8994 19.7661 11.4192 19.7661H16.1251C16.6449 19.7661 17.0663 20.1875 17.0663 20.7073C17.0663 21.2271 16.6449 21.6484 16.1251 21.6484H11.4192C10.8994 21.6484 10.478 21.2271 10.478 20.7073Z" fill="#141414"/>
              </g>
              <defs>
              <clipPath id="clip0_1851_32338">
              <rect width="32" height="32" fill="white" transform="translate(0.125)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>전체</em>
          </div>
        </a>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonMainTmpl2 = () => `
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt" aria-live="assertive"></span>
  <div class="skeleton-rec-group renew skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header">
      <div class="skeleton-title">상품</div>
    </div>
    <div class="skeleton-item01-group">
      <div class="skeleton-item01">
        <div class="skeleton-item0101"></div>
        <div class="skeleton-item0102"></div>
      </div>
      <div class="skeleton-item01">
        <div class="skeleton-item0101"></div>
        <div class="skeleton-item0102"></div>
      </div>
      <div class="skeleton-item01">
        <div class="skeleton-item0101"></div>
        <div class="skeleton-item0102"></div>
      </div>
      <div class="skeleton-item01">
        <div class="skeleton-item0101"></div>
        <div class="skeleton-item0102"></div>
      </div>
      <div class="skeleton-item01">
        <div class="skeleton-item0101"></div>
        <div class="skeleton-item0102"></div>
      </div>
    </div>
    <div class="skeleton-item02"></div>
    <div class="skeleton-item03-group">
      <div class="skeleton-item03">
        <div class="skeleton-item0301"></div>
        <div class="skeleton-item0302">
          <div class="skeleton-item030201">
            <div class="skeleton-item03020101"></div>
            <div class="skeleton-item03020102"></div>
          </div>
          <div class="skeleton-item030202">
            <div class="skeleton-item0302021"></div>
          </div>
        </div>
      </div>
      <div class="skeleton-item03">
        <div class="skeleton-item0301"></div>
        <div class="skeleton-item0302">
          <div class="skeleton-item030201">
            <div class="skeleton-item03020101"></div>
            <div class="skeleton-item03020102"></div>
          </div>
          <div class="skeleton-item030202">
            <div class="skeleton-item0302021"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="skeleton-item04"></div>
    <div class="skeleton-item05"></div>
    <div class="component-btn fixed-bottom home-tab-menu new-home">
      <div class="btn-group">
        <a class="btn-home-tab1" href="#none">
          <div class="btn-ico-item">  <!-- 23-01-26 : btn-ico-item 클래스 태그 안으로 변경 tab1 ~ tab4 -->
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8747 4.70508L25.5928 10.7532C26.0291 11.0718 26.2864 11.5759 26.2864 12.1117V24.6624C26.2864 25.5956 25.5203 26.3521 24.5752 26.3521H20.3856C19.8673 26.3521 19.4465 25.933 19.4445 25.4147L19.4415 24.6624V22.5119C19.4415 21.3666 18.2923 20.4382 16.8747 20.4382C15.457 20.4382 14.3078 21.3666 14.3078 22.5119V24.6624L14.3089 25.4096C14.3096 25.9294 13.8888 26.3514 13.369 26.3521L13.3677 26.3521H9.17412C8.22903 26.3521 7.46289 25.5956 7.46289 24.6624V12.1117C7.46289 11.5759 7.72026 11.0718 8.15652 10.7532L16.8747 4.70508Z" stroke="#141414" stroke-width="2"/>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>홈</em>
          </div>
        </a>
        <a class="btn-home-tab2 on" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_395_23607)">
              <path d="M21.3308 5.64844H11.919C8.80025 5.64844 6.27197 8.17671 6.27197 11.2955V20.7073C6.27197 23.826 8.80025 26.3543 11.919 26.3543H21.3308C24.4496 26.3543 26.9779 23.826 26.9779 20.7073V11.2955C26.9779 8.17671 24.4496 5.64844 21.3308 5.64844Z" fill="#0F0060" stroke="#0F0060" stroke-width="2"/>
              <path d="M17.5659 11.2947C17.5659 10.7749 17.1446 10.3535 16.6248 10.3535C16.105 10.3535 15.6836 10.7749 15.6836 11.2947V20.7065C15.6836 21.2263 16.105 21.6476 16.6248 21.6476C17.1446 21.6476 17.5659 21.2263 17.5659 20.7065V11.2947Z" fill="white"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.978 16.0002C10.978 15.4804 11.3994 15.0591 11.9192 15.0591H21.331C21.8508 15.0591 22.2721 15.4804 22.2721 16.0002C22.2721 16.52 21.8508 16.9414 21.331 16.9414H11.9192C11.3994 16.9414 10.978 16.52 10.978 16.0002Z" fill="white"/>
              </g>
              <defs>
              <clipPath id="clip0_395_23607">
              <rect width="32" height="32" fill="white" transform="translate(0.625)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>상품</em>
          </div>
        </a>
        <a class="btn-home-tab3" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32283)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3789 21.7526C25.248 21.839 25.0937 21.8839 24.9365 21.8811H7.75719C7.59703 21.8877 7.4386 21.8446 7.30391 21.7579C7.16907 21.6711 7.06454 21.5449 7.00438 21.3965C6.94548 21.2575 6.93048 21.1038 6.96173 20.9561C6.99282 20.8084 7.06845 20.6737 7.1786 20.5703L8.46654 19.2965C9.37761 18.4022 9.89104 17.1799 9.89136 15.9042V12.0645C9.89136 9.77164 11.1165 7.65261 13.1051 6.50631C15.0938 5.35988 17.5438 5.35988 19.5326 6.50631C21.5212 7.65273 22.7463 9.77164 22.7463 12.0645V15.9042C22.7468 17.1799 23.26 18.4022 24.1711 19.2965L25.4591 20.5703C25.5755 20.6693 25.6584 20.802 25.6962 20.9499C25.7341 21.0978 25.7251 21.2539 25.6706 21.3966C25.6117 21.5419 25.51 21.666 25.3789 21.7526Z" stroke="#141414" stroke-width="2"/>
              <path d="M12.3652 23.6836C12.3652 25.6762 14.1851 27.2914 16.43 27.2914C18.6749 27.2914 20.4947 25.6762 20.4947 23.6836" stroke="#141414" stroke-width="2"/>
              </g>
              <defs>
              <clipPath id="clip0_1851_32283">
              <rect width="32" height="32" fill="white" transform="translate(0.375)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>알림</em>
          </div>
        </a>
        <a class="btn-home-tab4" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32338)">
              <path d="M20.8308 5.64648H11.419C8.30025 5.64648 5.77197 8.17476 5.77197 11.2935V20.7053C5.77197 23.8241 8.30025 26.3524 11.419 26.3524H20.8308C23.9496 26.3524 26.4779 23.8241 26.4779 20.7053V11.2935C26.4779 8.17476 23.9496 5.64648 20.8308 5.64648Z" stroke="#141414" stroke-width="2"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 11.2952C10.478 10.7754 10.8994 10.354 11.4192 10.354H20.831C21.3508 10.354 21.7721 10.7754 21.7721 11.2952C21.7721 11.8149 21.3508 12.2363 20.831 12.2363H11.4192C10.8994 12.2363 10.478 11.8149 10.478 11.2952Z" fill="#141414"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 16.0002C10.478 15.4804 10.8994 15.0591 11.4192 15.0591H18.9486C19.4684 15.0591 19.8898 15.4804 19.8898 16.0002C19.8898 16.52 19.4684 16.9414 18.9486 16.9414H11.4192C10.8994 16.9414 10.478 16.52 10.478 16.0002Z" fill="#141414"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 20.7073C10.478 20.1875 10.8994 19.7661 11.4192 19.7661H16.1251C16.6449 19.7661 17.0663 20.1875 17.0663 20.7073C17.0663 21.2271 16.6449 21.6484 16.1251 21.6484H11.4192C10.8994 21.6484 10.478 21.2271 10.478 20.7073Z" fill="#141414"/>
              </g>
              <defs>
              <clipPath id="clip0_1851_32338">
              <rect width="32" height="32" fill="white" transform="translate(0.125)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>전체</em>
          </div>
        </a>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonMainTmpl3 = () => `
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt" aria-live="assertive"></span>
  <div class="skeleton-timeline-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header">
      <div class="skeleton-title">알림</div>
      <div class="right">
        <div class="btn-timeline-refresh ui-btn-animate">
          <span class="hide-txt">새로고침</span>
          <i class="ico-timeline-refresh" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <div class="skeleton-item01"></div>
    <div class="skeleton-item02-group">
      <div class="skeleton-item02-img"></div>
      <div class="skeleton-item02-box"></div>
    </div>
    <div class="skeleton-item02-group">
      <div class="skeleton-item02-img"></div>
      <div class="skeleton-item02-box"></div>
    </div>
    <div class="skeleton-item03-group">
      <div class="skeleton-item03-img"></div>
      <div class="skeleton-item03-box"></div>
    </div>
    <div class="skeleton-item04-group">
      <div class="skeleton-item04-box"></div>
    </div>
    <div class="skeleton-item04-group">
      <div class="skeleton-item04-box"></div>
    </div>
    <div class="skeleton-item04-group">
      <div class="skeleton-item04-box"></div>
    </div>
    <div class="skeleton-item04-group">
      <div class="skeleton-item04-box"></div>
    </div>
    
    <div class="component-btn fixed-bottom home-tab-menu new-home">
      <div class="btn-group">
        <a class="btn-home-tab1" href="#none">
          <div class="btn-ico-item">  <!-- 23-01-26 : btn-ico-item 클래스 태그 안으로 변경 tab1 ~ tab4 -->
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8747 4.70508L25.5928 10.7532C26.0291 11.0718 26.2864 11.5759 26.2864 12.1117V24.6624C26.2864 25.5956 25.5203 26.3521 24.5752 26.3521H20.3856C19.8673 26.3521 19.4465 25.933 19.4445 25.4147L19.4415 24.6624V22.5119C19.4415 21.3666 18.2923 20.4382 16.8747 20.4382C15.457 20.4382 14.3078 21.3666 14.3078 22.5119V24.6624L14.3089 25.4096C14.3096 25.9294 13.8888 26.3514 13.369 26.3521L13.3677 26.3521H9.17412C8.22903 26.3521 7.46289 25.5956 7.46289 24.6624V12.1117C7.46289 11.5759 7.72026 11.0718 8.15652 10.7532L16.8747 4.70508Z" stroke="#141414" stroke-width="2"/>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>홈</em>
          </div>
        </a>
        <a class="btn-home-tab2" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32306)">
                <path d="M21.3308 5.64844H11.919C8.80025 5.64844 6.27197 8.17671 6.27197 11.2955V20.7073C6.27197 23.826 8.80025 26.3543 11.919 26.3543H21.3308C24.4496 26.3543 26.9779 23.826 26.9779 20.7073V11.2955C26.9779 8.17671 24.4496 5.64844 21.3308 5.64844Z" stroke="#141414" stroke-width="2"/>
                <path d="M17.5659 11.2947C17.5659 10.7749 17.1446 10.3535 16.6248 10.3535C16.105 10.3535 15.6836 10.7749 15.6836 11.2947V20.7065C15.6836 21.2263 16.105 21.6476 16.6248 21.6476C17.1446 21.6476 17.5659 21.2263 17.5659 20.7065V11.2947Z" fill="#141414"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.978 16.0002C10.978 15.4804 11.3994 15.0591 11.9192 15.0591H21.331C21.8508 15.0591 22.2721 15.4804 22.2721 16.0002C22.2721 16.52 21.8508 16.9414 21.331 16.9414H11.9192C11.3994 16.9414 10.978 16.52 10.978 16.0002Z" fill="#141414"/>
                </g>
                <defs>
                <clipPath id="clip0_1851_32306">
                <rect width="32" height="32" fill="white" transform="translate(0.625)"/>
                </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>상품</em>
          </div>
        </a>
        <a class="btn-home-tab3 on" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_395_23682)">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3789 21.7526C25.248 21.839 25.0937 21.8839 24.9365 21.8811H7.75719C7.59703 21.8877 7.4386 21.8446 7.30391 21.7579C7.16907 21.6711 7.06454 21.5449 7.00438 21.3965C6.94548 21.2575 6.93048 21.1038 6.96173 20.9561C6.99282 20.8084 7.06845 20.6737 7.1786 20.5703L8.46654 19.2965C9.37761 18.4022 9.89104 17.1799 9.89136 15.9042V12.0645C9.89136 9.77164 11.1165 7.65261 13.1051 6.50631C15.0938 5.35988 17.5438 5.35988 19.5326 6.50631C21.5212 7.65273 22.7463 9.77164 22.7463 12.0645V15.9042C22.7468 17.1799 23.26 18.4022 24.1711 19.2965L25.4591 20.5703C25.5755 20.6693 25.6584 20.802 25.6962 20.9499C25.7341 21.0978 25.7251 21.2539 25.6706 21.3966C25.6117 21.5419 25.51 21.666 25.3789 21.7526Z" fill="#0F0060" stroke="#0F0060" stroke-width="2"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M12.3652 23.6836C12.3652 25.6762 14.1851 27.2914 16.43 27.2914C18.6749 27.2914 20.4947 25.6762 20.4947 23.6836" fill="#0F0060"/>
              <path d="M12.3652 23.6836C12.3652 25.6762 14.1851 27.2914 16.43 27.2914C18.6749 27.2914 20.4947 25.6762 20.4947 23.6836" stroke="#0F0060" stroke-width="2"/>
              </g>
              <defs>
              <clipPath id="clip0_395_23682">
              <rect width="32" height="32" fill="white" transform="translate(0.375)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>알림</em>
          </div>
        </a>
        <a class="btn-home-tab4" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32338)">
              <path d="M20.8308 5.64648H11.419C8.30025 5.64648 5.77197 8.17476 5.77197 11.2935V20.7053C5.77197 23.8241 8.30025 26.3524 11.419 26.3524H20.8308C23.9496 26.3524 26.4779 23.8241 26.4779 20.7053V11.2935C26.4779 8.17476 23.9496 5.64648 20.8308 5.64648Z" stroke="#141414" stroke-width="2"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 11.2952C10.478 10.7754 10.8994 10.354 11.4192 10.354H20.831C21.3508 10.354 21.7721 10.7754 21.7721 11.2952C21.7721 11.8149 21.3508 12.2363 20.831 12.2363H11.4192C10.8994 12.2363 10.478 11.8149 10.478 11.2952Z" fill="#141414"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 16.0002C10.478 15.4804 10.8994 15.0591 11.4192 15.0591H18.9486C19.4684 15.0591 19.8898 15.4804 19.8898 16.0002C19.8898 16.52 19.4684 16.9414 18.9486 16.9414H11.4192C10.8994 16.9414 10.478 16.52 10.478 16.0002Z" fill="#141414"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 20.7073C10.478 20.1875 10.8994 19.7661 11.4192 19.7661H16.1251C16.6449 19.7661 17.0663 20.1875 17.0663 20.7073C17.0663 21.2271 16.6449 21.6484 16.1251 21.6484H11.4192C10.8994 21.6484 10.478 21.2271 10.478 20.7073Z" fill="#141414"/>
              </g>
              <defs>
              <clipPath id="clip0_1851_32338">
              <rect width="32" height="32" fill="white" transform="translate(0.125)"/>
              </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>전체</em>
          </div>
        </a>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonMainTmpl4 = () => `
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt" aria-live="assertive"></span>
  <div class="skeleton-menu-group renewal skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header">
      <div class="skeleton-h-item00"></div>
    </div>
    <div class="skeleton-item00"></div>
    <div class="skeleton-item-group-01">
      <div class="skeleton-item01-group">
        <div class="skeleton-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
        <div class="skeleton-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
        <div class="skeleton-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
        <div class="skeleton-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
      </div>
      <div class="skeleton-item02-group">
        <div class="skeleton-item02"></div>
      </div>
    </div>
    <div class="skeleton-item03-group">
      <div class="skeleton-item03-item"></div>
      <div class="skeleton-item03-item"></div>
      <div class="skeleton-item03-item"></div>
      <div class="skeleton-item03-item"></div>
      <div class="skeleton-item03-item"></div>
      <div class="skeleton-item03-item"></div>
    </div>

    <div class="component-btn fixed-bottom home-tab-menu new-home">
      <div class="btn-group">
        <a class="btn-home-tab1" href="#none">
          <div class="btn-ico-item">
            <!-- 23-01-26 : btn-ico-item 클래스 태그 안으로 변경 tab1 ~ tab4 -->
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8747 4.70508L25.5928 10.7532C26.0291 11.0718 26.2864 11.5759 26.2864 12.1117V24.6624C26.2864 25.5956 25.5203 26.3521 24.5752 26.3521H20.3856C19.8673 26.3521 19.4465 25.933 19.4445 25.4147L19.4415 24.6624V22.5119C19.4415 21.3666 18.2923 20.4382 16.8747 20.4382C15.457 20.4382 14.3078 21.3666 14.3078 22.5119V24.6624L14.3089 25.4096C14.3096 25.9294 13.8888 26.3514 13.369 26.3521L13.3677 26.3521H9.17412C8.22903 26.3521 7.46289 25.5956 7.46289 24.6624V12.1117C7.46289 11.5759 7.72026 11.0718 8.15652 10.7532L16.8747 4.70508Z" stroke="#141414" stroke-width="2" />
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>홈</em>
          </div>
        </a>
        <a class="btn-home-tab2" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32306)">
                <path d="M21.3308 5.64844H11.919C8.80025 5.64844 6.27197 8.17671 6.27197 11.2955V20.7073C6.27197 23.826 8.80025 26.3543 11.919 26.3543H21.3308C24.4496 26.3543 26.9779 23.826 26.9779 20.7073V11.2955C26.9779 8.17671 24.4496 5.64844 21.3308 5.64844Z" stroke="#141414" stroke-width="2" />
                <path d="M17.5659 11.2947C17.5659 10.7749 17.1446 10.3535 16.6248 10.3535C16.105 10.3535 15.6836 10.7749 15.6836 11.2947V20.7065C15.6836 21.2263 16.105 21.6476 16.6248 21.6476C17.1446 21.6476 17.5659 21.2263 17.5659 20.7065V11.2947Z" fill="#141414" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.978 16.0002C10.978 15.4804 11.3994 15.0591 11.9192 15.0591H21.331C21.8508 15.0591 22.2721 15.4804 22.2721 16.0002C22.2721 16.52 21.8508 16.9414 21.331 16.9414H11.9192C11.3994 16.9414 10.978 16.52 10.978 16.0002Z" fill="#141414" />
              </g>
              <defs>
                <clipPath id="clip0_1851_32306">
                  <rect width="32" height="32" fill="white" transform="translate(0.625)" />
                </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>상품</em>
          </div>
        </a>
        <a class="btn-home-tab3" href="#none">
          <div class="btn-ico-item">
            <!--s: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_1851_32283)">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M25.3789 21.7526C25.248 21.839 25.0937 21.8839 24.9365 21.8811H7.75719C7.59703 21.8877 7.4386 21.8446 7.30391 21.7579C7.16907 21.6711 7.06454 21.5449 7.00438 21.3965C6.94548 21.2575 6.93048 21.1038 6.96173 20.9561C6.99282 20.8084 7.06845 20.6737 7.1786 20.5703L8.46654 19.2965C9.37761 18.4022 9.89104 17.1799 9.89136 15.9042V12.0645C9.89136 9.77164 11.1165 7.65261 13.1051 6.50631C15.0938 5.35988 17.5438 5.35988 19.5326 6.50631C21.5212 7.65273 22.7463 9.77164 22.7463 12.0645V15.9042C22.7468 17.1799 23.26 18.4022 24.1711 19.2965L25.4591 20.5703C25.5755 20.6693 25.6584 20.802 25.6962 20.9499C25.7341 21.0978 25.7251 21.2539 25.6706 21.3966C25.6117 21.5419 25.51 21.666 25.3789 21.7526Z" stroke="#141414" stroke-width="2" />
                <path d="M12.3652 23.6836C12.3652 25.6762 14.1851 27.2914 16.43 27.2914C18.6749 27.2914 20.4947 25.6762 20.4947 23.6836" stroke="#141414" stroke-width="2" />
              </g>
              <defs>
                <clipPath id="clip0_1851_32283">
                  <rect width="32" height="32" fill="white" transform="translate(0.375)" />
                </clipPath>
              </defs>
            </svg>
            <!--e: FETASK-713 2023-03-10 스켈레톤 웹뷰 대응의 건 수정 -->
            <em>알림</em>
          </div>
        </a>
        <a class="btn-home-tab4 on" href="#none">
          <div class="btn-ico-item">
            <svg class="btn-home-svgicon" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_395_23757)">
                <path d="M20.8308 5.64648H11.419C8.30025 5.64648 5.77197 8.17476 5.77197 11.2935V20.7053C5.77197 23.8241 8.30025 26.3524 11.419 26.3524H20.8308C23.9496 26.3524 26.4779 23.8241 26.4779 20.7053V11.2935C26.4779 8.17476 23.9496 5.64648 20.8308 5.64648Z" fill="#0F0060" stroke="#0F0060" stroke-width="2" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 11.2932C10.478 10.7734 10.8994 10.352 11.4192 10.352H20.831C21.3508 10.352 21.7721 10.7734 21.7721 11.2932C21.7721 11.813 21.3508 12.2344 20.831 12.2344H11.4192C10.8994 12.2344 10.478 11.813 10.478 11.2932Z" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 15.9983C10.478 15.4785 10.8994 15.0571 11.4192 15.0571H18.9486C19.4684 15.0571 19.8898 15.4785 19.8898 15.9983C19.8898 16.5181 19.4684 16.9395 18.9486 16.9395H11.4192C10.8994 16.9395 10.478 16.5181 10.478 15.9983Z" fill="white" />
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.478 20.7053C10.478 20.1855 10.8994 19.7641 11.4192 19.7641H16.1251C16.6449 19.7641 17.0663 20.1855 17.0663 20.7053C17.0663 21.2251 16.6449 21.6465 16.1251 21.6465H11.4192C10.8994 21.6465 10.478 21.2251 10.478 20.7053Z" fill="white" />
              </g>
              <defs>
                <clipPath id="clip0_395_23757">
                  <rect width="32" height="32" fill="white" transform="translate(0.125)" />
                </clipPath>
              </defs>
            </svg>
            <em>전체</em>
          </div>
        </a>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonMainTmpl5 = () =>`
<div class="component-skeleton-sub bg-lightgray">
  <!--skeletonSource-->
  <span class="hide-txt" aria-live="assertive"></span>
  <div class="skeleton-layout-group skeleton-easyhome-group skeleton-animation-all">
    <!-- Easy Home Mode -->
    <div class="skeleton-easyhome-frm">
      <div class="skeleton-item01">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-item02">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-item03">
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-item04">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-item05">
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-item06">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block01"></div>
      </div>
    </div>
    <!--// Easy Home Mode -->
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonSubTmpl1 = () =>`
<div class="component-skeleton-sub bg-lightgray">
  <!-- FETASK-849 2023-05-19 클래스변경(bg-gray bg-lightgray) -->
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-benefit-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header skeleton-header-bg01">
      <div class="skeleton-btn-back">
        <i class="ico-back" aria-hidden="true"></i>
      </div>
      <div class="skeleton-tit-header">
        <span class="hide-txt">혜택</span>
      </div>
    </div>
    <div class="skeleton-item01-group">
      <div class="skeleton-item01-1"></div>
      <div class="skeleton-item01-2"></div>
    </div>
    <div class="skeleton-swiper-container">
      <div class="skeleton-swiper-group">
        <div class="skeleton-swiper-item"></div>
        <div class="skeleton-swiper-item"></div>
      </div>
      <div class="skeleton-dot-group">
        <div class="skeleton-dot-item"></div>
        <div class="skeleton-dot-item"></div>
        <div class="skeleton-dot-item"></div>
      </div>
    </div>
    <div class="skeleton-item-container">
      <div class="skeleton-item02-group">
        <div class="skeleton-item02"></div>
        <div class="skeleton-item02"></div>
        <div class="skeleton-item02"></div>
        <div class="skeleton-item02"></div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonSubTmpl2 = () =>`
<div class="component-skeleton-sub bg-lightgray">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-layout-group skeleton-animation-all">
    <div class="skeleton-header skeleton-header-bg02">
      <div class="skeleton-btn-back">
        <i class="ico-back" aria-hidden="true"></i>
      </div>
      <div class="skeleton-tit-header">
        <!-- <span>계좌목록</span> -->
      </div>
    </div>
    <div class="container-bgwhite">
      <!-- FETASK-849 2023-04-21 container-bgwhite 클래스 블럭 추가 -->
      <div class="skeleton-group group-gray" aria-hidden="true">
        <div class="skeleton-item mt24">
          <div class="skeleton-col">
            <div class="skeleton-field w30 h20 field-lightgray2"></div> <!-- FETASK-849 2023-04-11 h24->h20으로 변경 -->
          </div>
          <div class="skeleton-col jc-sb">
            <div class="skeleton-field w20 h14 field-lightgray2"></div> <!-- FETASK-849 2023-04-11 h16->h14으로 변경 -->
            <div class="skeleton-field w40 h14 field-lightgray2"></div> <!-- FETASK-849 2023-04-11 h16->h14으로 변경 -->
          </div>
        </div>
        <div class="skeleton-item mt20 radius item-white pd20">
          <!-- FETASK-849 2023-04-11 mt24->mt20으로 변경 -->
          <div class="skeleton-col fd-c">
            <div class="skeleton-field w30 h14 field-gray"></div> <!-- FETASK-849 2023-04-11 h16->h14으로 변경 -->
            <div class="skeleton-field mt6 w40 h14 field-gray"></div> <!-- FETASK-849 2023-04-11 h7->h14으로 변경 -->
          </div>
          <div class="skeleton-col jc-fe mt20">
            <!-- FETASK-849 2023-04-11 mt20 추가 -->
            <div class="skeleton-field w50 h24 field-gray"></div>
          </div>
        </div>
        <div class="skeleton-item radius item-white pd20">
          <!-- FETASK-849 2023-04-11 mt24 삭제 -->
          <div class="skeleton-col fd-c">
            <div class="skeleton-field w30 h14 field-gray"></div> <!-- FETASK-849 2023-04-11 h16->h14으로 변경 -->
            <div class="skeleton-field mt6 w40 h14 field-gray"></div> <!-- FETASK-849 2023-04-11 h7->h14으로 변경 -->
          </div>
          <div class="skeleton-col jc-fe mt20">
            <!-- FETASK-849 2023-04-11 mt20 추가 -->
            <div class="skeleton-field w50 h24 field-gray"></div>
          </div>
        </div>
      </div>
      <div class="skeleton-group pdtb0" aria-hidden="true">
        <div class="skeleton-item flexlist pdtb0 b-line mg0">
          <!-- FETASK-849 2023-04-11 flexlist 클래스 추가, pdtb16 > pdtb0 로 변경, pdlr20 삭제 -->
          <div class="skeleton-col jc-sb">
            <div class="skeleton-field w50 h16 field-gray"></div>
            <div class="skeleton-arrow ico-arrow-sbr"></div>
          </div>
        </div>
        <div class="skeleton-item flexlist pdtb0 b-line mg0">
          <!-- FETASK-849 2023-04-11 flexlist 클래스 추가, pdtb16 > pdtb0 로 변경, pdlr20 삭제 -->
          <div class="skeleton-col jc-sb">
            <div class="skeleton-field w50 h16 field-gray"></div>
            <div class="skeleton-arrow ico-arrow-sbr"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonSubTmpl3 = () =>`
<div class="component-skeleton-sub bg-lightgray">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-layout-group skeleton-animation-all">
    <div class="skeleton-header skeleton-header-bg02">
      <div class="skeleton-btn-back">
        <i class="ico-back" aria-hidden="true"></i>
      </div>
      <div class="skeleton-tit-header">
        <!-- <span>거래내역</span> -->
      </div>
    </div>
    <div class="container-bgwhite">
      <!-- FETASK-849 2023-04-21 container-bgwhite 클래스 블럭 추가 -->
      <div class="skeleton-group group-gray" aria-hidden="true">
        <div class="skeleton-item">
          <div class="skeleton-col fd-c">
            <div class="skeleton-field w40 h20 field-lightgray2"></div> <!-- FETASK-849 2023-04-11 h16->h20 으로 변경 -->
            <div class="skeleton-field mt16 w30 h14 field-lightgray2"></div> <!-- FETASK-849 2023-04-11 h7->h14, mt6->mt16 으로 변경 -->
          </div>
          <div class="skeleton-col jc-fe trading-mg">
            <!-- FETASK-849 2023-04-11 trading-mg 클래스 추가 -->
            <div class="skeleton-field w60 h24 field-lightgray2"></div>
          </div>
        </div>
      </div>
      <div class="skeleton-group pdtb0" aria-hidden="true">
        <div class="skeleton-item tradelist pdlr20 mg0">
          <!-- FETASK-849 2023-04-11 pdtb16->tradelist 클래스로 변경, b-line 삭제 -->
          <div class="skeleton-col">
            <div class="skeleton-field w30 h16 field-gray"></div>
          </div>
          <div class="skeleton-col jc-sb mt8">
            <!-- FETASK-849 2023-04-11 mt8 클래스 추가 -->
            <div class="skeleton-field w40 h24 field-gray"></div>
            <div class="skeleton-field w40 h24 field-gray"></div>
          </div>
        </div>
        <div class="skeleton-item tradelist pdlr20 mg0">
          <!-- FETASK-849 2023-04-11 pdtb16->tradelist 클래스로 변경, b-line 삭제 -->
          <div class="skeleton-col">
            <div class="skeleton-field w30 h16 field-gray"></div>
          </div>
          <div class="skeleton-col jc-sb mt8">
            <!-- FETASK-849 2023-04-11 mt8 클래스 추가 -->
            <div class="skeleton-field w40 h24 field-gray"></div>
            <div class="skeleton-field w40 h24 field-gray"></div>
          </div>
        </div>
        <div class="skeleton-item tradelist pdlr20 mg0">
          <!-- FETASK-849 2023-04-11 pdtb16->tradelist 클래스로 변경, b-line 삭제 -->
          <div class="skeleton-col">
            <div class="skeleton-field w30 h16 field-gray"></div>
          </div>
          <div class="skeleton-col jc-sb mt8">
            <!-- FETASK-849 2023-04-11 mt8 클래스 추가 -->
            <div class="skeleton-field w40 h24 field-gray"></div>
            <div class="skeleton-field w40 h24 field-gray"></div>
          </div>
        </div>
        <div class="skeleton-item tradelist pdlr20 mg0">
          <!-- FETASK-849 2023-04-11 pdtb16->tradelist 클래스로 변경, b-line 삭제 -->
          <div class="skeleton-col">
            <div class="skeleton-field w30 h16 field-gray"></div>
          </div>
          <div class="skeleton-col jc-sb mt8">
            <!-- FETASK-849 2023-04-11 mt8 클래스 추가 -->
            <div class="skeleton-field w40 h24 field-gray"></div>
            <div class="skeleton-field w40 h24 field-gray"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonSubTmpl4 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-transfer-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header"></div>
    <div class="skeleton-item01"></div>
    <div class="skeleton-item02"></div>
    <div class="skeleton-item03"></div>
    <div class="skeleton-item04"></div>
    <div class="skeleton-item-container">
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item03-img"></div>
        <div class="skeleton-item03-txt">
          <div class="skeleton-item03-txt01"></div>
          <div class="skeleton-item03-txt02"></div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonSubTmpl5 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-realestate-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header">
      <div class="skeleton-btn-back">
        <i class="ico-back" aria-hidden="true"></i>
      </div>
    </div>
    <div class="skeleton-item01"></div>
    <div class="skeleton-item02"></div>
    <div class="skeleton-item03"></div>
    <div class="skeleton-item04"></div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonSubTmpl6 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-pubsub-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header">
      <div class="skeleton-btn-back">
        <i class="ico-back" aria-hidden="true"></i>
      </div>
    </div>
    <div class="skeleton-pubsub-frm">
      <div class="skeleton-item01">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block02"></div>
      </div>
      <div class="skeleton-item02">
        <div class="skeleton-item0201">
          <div class="skeleton-block01"></div>
        </div>
        <div class="skeleton-item0202">
          <div class="skeleton-block01"></div>
          <div class="skeleton-block01"></div>
        </div>
        <div class="skeleton-item0203">
          <div class="skeleton-block01"></div>
          <div class="skeleton-block01"></div>
        </div>
        <div class="skeleton-item0204">
          <div class="skeleton-block01"></div>
          <div class="skeleton-block02"></div>
        </div>
        <div class="skeleton-item0205">
          <div class="skeleton-block01"></div>
          <div class="skeleton-block02"></div>
        </div>
        <div class="skeleton-item0206">
          <div class="skeleton-block01"></div>
        </div>
      </div>
      <div class="skeleton-item03">
        <div class="skeleton-item0301">
          <div class="skeleton-block01"></div>
        </div>
      </div>
      <div class="skeleton-item04">
        <div class="skeleton-item0401">
          <div class="skeleton-block01"></div>
          <div class="skeleton-block02"></div>
        </div>
        <div class="skeleton-item0402">
          <div class="skeleton-block01"></div>
          <div class="skeleton-block02"></div>
        </div>
        <div class="skeleton-item0403">
          <div class="skeleton-block01"></div>
          <div class="skeleton-block02"></div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonSubTmpl7 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-layout-group skeleton-animation-all">
    <div class="skeleton-header skeleton-header-bg01">
      <div class="skeleton-btn-back">
        <i class="ico-back" aria-hidden="true"></i>
      </div>
      <div class="skeleton-tit-header">
        <div class="skeleton-field h25 w30 field-lightgray2"></div>
      </div>
    </div>
    <div class="skeleton-container">
      <div class="skeleton-group sub7 group-gray">
        <div class="skeleton-item sub7-box01">
          <div class="skeleton-col">
            <div class="skeleton-field h30"></div>
            <div class="skeleton-field h30 mt4"></div>
            <div class="skeleton-field h20 w70 mt10"></div>
          </div>
          <div class="skeleton-col">
            <div class="skeleton-field"></div>
          </div>
        </div>
      </div>
      <div class="skeleton-group pdtb0">
        <div class="skeleton-item mt56">
          <div class="skeleton-col sub7-box02">
            <div class="skeleton-field"></div>
          </div>
        </div>
        <div class="skeleton-item mt48">
          <div class="skeleton-col fd-c sub7-box03">
            <div class="skeleton-field h20 w80"></div>
            <div class="skeleton-field h20 w100 mt8"></div>
            <div class="skeleton-field h20 w80 mt8"></div>
          </div>
        </div>
        <div class="skeleton-item mt48">
          <div class="skeleton-col sub7-box04">
            <div class="skeleton-field"></div>
            <div class="skeleton-field"></div>
          </div>
        </div>
        <div class="skeleton-item mt48">
          <div class="skeleton-col jc-c sub7-box05">
            <div class="skeleton-field"></div>
          </div>
        </div>
        <div class="skeleton-item mt64">
          <div class="skeleton-col sub7-box06">
            <div class="skeleton-field"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
// CHPFMTASK-1167 one 체크카드 
export const getSkeletonSubTmpl8 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-cardlist-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header"></div>
    <div class="skeleton-item-container">
      <div class="skeleton-item01-group">
        <div class="skeleton-item-txt01"></div>
        <div class="skeleton-item-txt02"></div>
      </div>
      <div class="skeleton-item02-group">
        <div class="skeleton-item-txt01"></div>
        <div class="skeleton-col">
          <div class="skeleton-item-img"></div>
          <div class="skeleton-txt01">
            <div class="skeleton-item-txt02"></div>
            <div class="skeleton-item-txt03"></div>
          </div>
        </div>
        <div class="skeleton-col">
          <div class="skeleton-item-img"></div>
          <div class="skeleton-txt01">
            <div class="skeleton-item-txt02"></div>
            <div class="skeleton-item-txt03"></div>
          </div>
        </div>
        <div class="skeleton-item-banner"></div>
      </div>
      <div class="skeleton-item03-group">
        <div class="skeleton-item-header">
          <div class="skeleton-item-txt01"></div>
          <div class="skeleton-item-txt02"></div>
        </div>
        <div class="skeleton-item-list">
          <div class="skeleton-item-txt01"></div>
          <div class="skeleton-col">
            <div class="skeleton-item-img"></div>
            <div class="skeleton-txt01">
              <div class="skeleton-item-txt02"></div>
              <div class="skeleton-item-txt03"></div>
            </div>
            <div class="skeleton-txt02">
              <div class="skeleton-item-txt04"></div>
              <div class="skeleton-item-txt04"></div>
            </div>
          </div>
          <div class="skeleton-col">
            <div class="skeleton-item-img"></div>
            <div class="skeleton-txt01">
              <div class="skeleton-item-txt02"></div>
              <div class="skeleton-item-txt03"></div>
            </div>
            <div class="skeleton-txt02">
              <div class="skeleton-item-txt04"></div>
              <div class="skeleton-item-txt04"></div>
            </div>
          </div>
          <div class="skeleton-col">
            <div class="skeleton-item-img"></div>
            <div class="skeleton-txt01">
              <div class="skeleton-item-txt02"></div>
              <div class="skeleton-item-txt03"></div>
            </div>
            <div class="skeleton-txt02">
              <div class="skeleton-item-txt04"></div>
              <div class="skeleton-item-txt04"></div>
            </div>
          </div>
        </div>
        <div class="skeleton-item-list">
          <div class="skeleton-item-txt01"></div>
          <div class="skeleton-col">
            <div class="skeleton-item-img"></div>
            <div class="skeleton-txt01">
              <div class="skeleton-item-txt02"></div>
              <div class="skeleton-item-txt03"></div>
            </div>
            <div class="skeleton-txt02">
              <div class="skeleton-item-txt04"></div>
              <div class="skeleton-item-txt04"></div>
            </div>
          </div>
          <div class="skeleton-col">
            <div class="skeleton-item-img"></div>
            <div class="skeleton-txt01">
              <div class="skeleton-item-txt02"></div>
              <div class="skeleton-item-txt03"></div>
            </div>
            <div class="skeleton-txt02">
              <div class="skeleton-item-txt04"></div>
              <div class="skeleton-item-txt04"></div>
            </div>
          </div>
          <div class="skeleton-col">
            <div class="skeleton-item-img"></div>
            <div class="skeleton-txt01">
              <div class="skeleton-item-txt02"></div>
              <div class="skeleton-item-txt03"></div>
            </div>
            <div class="skeleton-txt02">
              <div class="skeleton-item-txt04"></div>
              <div class="skeleton-item-txt04"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`


export const getSkeletonHomeTmpl1 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-main-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group">
      <div class="skeleton-home-header-item01"></div>
    </div>
    <div class="skeleton-home01-group">
      <div class="skeleton-home-item01"></div>
      <div class="skeleton-home-item02"></div>
      <div class="skeleton-home-item03"></div>
      <div class="skeleton-home-item04"></div>
      <div class="skeleton-home-item05"></div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl2 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-main-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group">
      <div class="skeleton-home-header-item01"></div>
    </div>
    <div class="skeleton-benefit01-group">
      <div class="skeleton-home-item01"></div>
      <div class="skeleton-home-item02"></div>
    </div>
    <div class="skeleton-benefit02-group">
      <div class="skeleton-home-item"></div>
      <div class="skeleton-home-item"></div>
      <div class="skeleton-home-item"></div>
      <div class="skeleton-home-item"></div>
    </div>
    <div class="skeleton-benefit01-group">
      <div class="skeleton-home-item01"></div>
      <div class="skeleton-home-item02"></div>
    </div>
    <div class="skeleton-benefit03-group">
      <div class="skeleton-benefit03-group-item">
        <div class="skeleton-benefit03-group-item-row"></div>
        <div class="skeleton-benefit03-group-item-row">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
      <div class="skeleton-benefit03-group-item">
        <div class="skeleton-benefit03-group-item-row"></div>
        <div class="skeleton-benefit03-group-item-row">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl3 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-main-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group">
      <div class="skeleton-home-header-item01"></div>
    </div>
    <div class="skeleton-finding01-group">
      <div class="skeleton-finding-item01"></div>
      <div class="skeleton-finding-item02"></div>
      <div class="skeleton-finding-item03"></div>
      <div class="skeleton-finding-item03"></div>
      <div class="skeleton-finding-item03"></div>
      <div class="skeleton-finding-item03"></div>
      <div class="skeleton-finding-item02"></div>
    </div>
    <div class="skeleton-finding02-group">
      <div class="skeleton-finding-item01"></div>
    </div>
    <div class="skeleton-finding03-group">
      <div class="skeleton-finding-item"></div>
      <div class="skeleton-finding-item"></div>
      <div class="skeleton-finding-item"></div>
      <div class="skeleton-finding-item"></div>
    </div>
    <div class="skeleton-finding02-group">
      <div class="skeleton-finding-item01"></div>
    </div>
    <div class="skeleton-finding04-group">
      <div class="skeleton-finding04-group1">
        <div class="skeleton-finding04-item01"></div>
        <div class="skeleton-finding04-item02"></div>
      </div>
      <div class="skeleton-finding04-group2"></div>
      <div class="skeleton-finding04-group3"></div>
    </div>
    <div class="skeleton-finding04-group type2">
      <div class="skeleton-finding04-group1">
        <div class="skeleton-finding04-item01"></div>
        <div class="skeleton-finding04-item02"></div>
      </div>
      <div class="skeleton-finding04-group2">
        <div></div>
      </div>
      <div class="skeleton-finding04-group2-1">
        <div class="skeleton-finding04-item01"></div>
        <div class="skeleton-finding04-item02-1">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding04-item02-1">
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl4 = () =>`
<div class="component-skeleton-sub finding-prod">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-white-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-finding-prod-wrap">
      <div class="skeleton-finding-prod-group">
        <div class="skeleton-finding-item"></div>
      </div>
      <div class="skeleton-finding-prod-group2">
        <div class="skeleton-finding-item line01">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line02">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line03">
          <div></div>
        </div>
      </div>
      <div class="skeleton-finding-prod-group2">
        <div class="skeleton-finding-item line01">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line02">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line03">
          <div></div>
        </div>
      </div>
      <div class="skeleton-finding-prod-group2">
        <div class="skeleton-finding-item line01">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line02">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line03">
          <div></div>
        </div>
      </div>
      <div class="skeleton-finding-prod-group2">
        <div class="skeleton-finding-item line01">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line02">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line03">
          <div></div>
        </div>
      </div>
      <div class="skeleton-finding-prod-group">
        <div class="skeleton-finding-item"></div>
      </div>
      <div class="skeleton-finding-prod-group2">
        <div class="skeleton-finding-item line01">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line02">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line03">
          <div></div>
        </div>
      </div>
      <div class="skeleton-finding-prod-group2">
        <div class="skeleton-finding-item line01">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line02">
          <div></div>
          <div></div>
        </div>
        <div class="skeleton-finding-item line03">
          <div></div>
        </div>
      </div>
    </div>

  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl5 = () =>`
<div class="component-skeleton-sub ceo-home">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-white-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-ceo-header">
      <div class="skeleton-ceo-header-item">
        <div class="skeleton-ceo-item"></div>
      </div>
      <div class="skeleton-ceo-header-item">
        <div class="skeleton-ceo-item"></div>
      </div>
    </div>
    <div class="skeleton-ceo-group3">
      <div class="skeleton-ceo-group3-item01"></div>
      <div class="skeleton-ceo-group3-item02"></div>
      <div class="skeleton-ceo-group3-item03"></div>
      <div class="skeleton-ceo-group3-item04">
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="skeleton-ceo-group2-wrap">
      <div class="skeleton-ceo-group2">
        <div class="skeleton-ceo-group2-item01"></div>
        <div class="skeleton-ceo-group2-item02"></div>
      </div>
      <div class="skeleton-ceo-group2">
        <div class="skeleton-ceo-group2-item01"></div>
        <div class="skeleton-ceo-group2-item02"></div>
      </div>
      <div class="skeleton-ceo-group2">
        <div class="skeleton-ceo-group2-item01"></div>
        <div class="skeleton-ceo-group2-item02"></div>
      </div>
    </div>
    <div class="skeleton-ceo-group2">
      <div class="skeleton-ceo-group2-item01"></div>
      <div class="skeleton-ceo-group2-item03"></div>
    </div>
    <div class="skeleton-ceo-group2-wrap">
      <div class="skeleton-ceo-group2">
        <div class="skeleton-ceo-group2-item01"></div>
        <div class="skeleton-ceo-group2-item02"></div>
      </div>
      <div class="skeleton-ceo-group2">
        <div class="skeleton-ceo-group2-item01"></div>
        <div class="skeleton-ceo-group2-item02"></div>
      </div>
      <div class="skeleton-ceo-group2">
        <div class="skeleton-ceo-group2-item01"></div>
        <div class="skeleton-ceo-group2-item02"></div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl6 = () =>`
<div class="component-skeleton-sub bg-qua">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-main-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group"></div>
    <div class="skeleton-simple-group">
      <div class="skeleton-simple-item02">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-simple-item03">
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-simple-item04">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-simple-item05">
        <div class="skeleton-block01"></div>
      </div>
      <div class="skeleton-simple-item06">
        <div class="skeleton-block01"></div>
        <div class="skeleton-block01"></div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl7 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-allmenu-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-allmenu-group01">
      <div class="skeleton-allmenu-group01-item01"></div>
      <div class="skeleton-allmenu-group01-item02"></div>
    </div>

    <div class="skeleton-allmenu-group02">
      <div class="skeleton-allmenu-group02-1">
        <div class="skeleton-allmenu-group02-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
        <div class="skeleton-allmenu-group02-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
        <div class="skeleton-allmenu-group02-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
        <div class="skeleton-allmenu-group02-item01">
          <div class="skeleton-item01-img"></div>
          <div class="skeleton-item01-txt"></div>
        </div>
      </div>
    </div>

    <div class="skeleton-allmenu-group03">
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
    </div>
    <div class="skeleton-allmenu-group03">
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
      <div class="skeleton-allmenu-group03-item"></div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl8 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-white-group skeleton-invest-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group">
      <div class="skeleton-home-header-item01"></div>
    </div>
    <div class="skeleton-invest-header">
      <div class="skeleton-invest-header-item on">
        <div class="skeleton-invest-item"></div>
      </div>
      <div class="skeleton-invest-header-item">
        <div class="skeleton-invest-item"></div>
      </div>
      <div class="skeleton-invest-header-item">
        <div class="skeleton-invest-item"></div>
      </div>
    </div>
    <div class="skeleton-invest-group1">
      <div class="skeleton-invest-item01"></div>
      <div class="skeleton-invest-item02"></div>
      <div class="skeleton-invest-item03"></div>
      <div class="skeleton-invest-item04"></div>
      <div class="skeleton-invest-item05"></div>
    </div>
    <div class="skeleton-invest-group2">
      <div class="skeleton-invest-item01"></div>
      <div class="skeleton-invest-item02"></div>
      <div class="skeleton-invest-item03"></div>
      <div class="skeleton-invest-item04"></div>
    </div>
    <div class="skeleton-invest-group3">
      <div class="skeleton-invest-item01"></div>
      <div class="skeleton-invest-item02"></div>
      <div class="skeleton-invest-item03"></div>
      <div class="skeleton-invest-item04"></div>
      <div class="skeleton-invest-item05"></div>
    </div>
    <div class="skeleton-invest-group4">
      <div class="skeleton-invest-item01"></div>
    </div>
    <div class="skeleton-invest-group5">
      <div class="skeleton-invest-item01"></div>
      <div class="skeleton-invest-item02"></div>
      <div class="skeleton-invest-item03"></div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl9 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-white-group skeleton-myinvest-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group">
      <div class="skeleton-home-header-item01"></div>
    </div>
    <div class="skeleton-myinvest-header">
      <div class="skeleton-myinvest-header-item">
        <div class="skeleton-myinvest-item"></div>
      </div>
      <div class="skeleton-myinvest-header-item on">
        <div class="skeleton-myinvest-item"></div>
      </div>
      <div class="skeleton-myinvest-header-item">
        <div class="skeleton-myinvest-item"></div>
      </div>
    </div>
    <div class="skeleton-myinvest-group1">
      <div class="skeleton-myinvest-item01">
        <div class="skeleton-myinvest-item"></div>
      </div>
    </div>
    <div class="skeleton-myinvest-group2">
      <div class="skeleton-myinvest-item01"></div>
      <div class="skeleton-myinvest-item02"></div>
      <div class="skeleton-myinvest-item03"></div>
      <div class="skeleton-myinvest-item04"></div>
    </div>
    <div class="skeleton-myinvest-group3">
      <div class="skeleton-myinvest-row">
        <div class="skeleton-myinvest-col01">
          <div class="skeleton-myinvest-item01"></div>
        </div>
        <div class="skeleton-myinvest-col02">
          <div class="skeleton-myinvest-item01"></div>
          <div class="skeleton-myinvest-item02"></div>
        </div>
      </div>
      <div class="skeleton-myinvest-row">
        <div class="skeleton-myinvest-col01">
          <div class="skeleton-myinvest-item01"></div>
        </div>
        <div class="skeleton-myinvest-col02">
          <div class="skeleton-myinvest-item01"></div>
          <div class="skeleton-myinvest-item02"></div>
        </div>
      </div>
    </div>
    <div class="skeleton-myinvest-group4">
      <div class="skeleton-myinvest-item01"></div>
    </div>
    <div class="skeleton-myinvest-header01">
      <div class="skeleton-myinvest-header-item">
        <div class="skeleton-myinvest-item"></div>
      </div>
      <div class="skeleton-myinvest-header-item on">
        <div class="skeleton-myinvest-item"></div>
      </div>
    </div>
    <div class="skeleton-myinvest-group5">
      <div class="skeleton-myinvest-row">
        <div class="skeleton-myinvest-col01">
          <div class="skeleton-myinvest-item01"></div>
        </div>
        <div class="skeleton-myinvest-col02">
          <div class="skeleton-myinvest-item01"></div>
        </div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmpl10 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-white-group skeleton-insight-group skeleton-animation-all" aria-hidden="true">
    <div class="home-header-group">
      <div class="skeleton-home-header-item01"></div>
    </div>
    <div class="skeleton-insight-header">
      <div class="skeleton-insight-header-item">
        <div class="skeleton-insight-item"></div>
      </div>
      <div class="skeleton-insight-header-item">
        <div class="skeleton-insight-item"></div>
      </div>
      <div class="skeleton-insight-header-item on">
        <div class="skeleton-insight-item"></div>
      </div>
    </div>
    <div class="skeleton-insight-group1">
      <div class="skeleton-insight-item01">
        <div class="skeleton-insight-item"></div>
      </div>
    </div>
    <div class="skeleton-insight-group2">
      <div class="skeleton-insight-item01"></div>
    </div>
    <div class="skeleton-insight-group3">
      <div class="skeleton-insight-row">
        <div class="skeleton-insight-col01">
          <div class="skeleton-insight-item01"></div>
        </div>
        <div class="skeleton-insight-col02">
          <div class="skeleton-insight-item01"></div>
          <div class="skeleton-insight-item02"></div>
          <div class="skeleton-insight-item03"></div>
        </div>
      </div>
    </div>
    <div class="skeleton-insight-group4">
      <div class="skeleton-insight-item01"></div>
    </div>
    <div class="skeleton-insight-group5">
      <div class="skeleton-insight-item"></div>
      <div class="skeleton-insight-item"></div>
    </div>
    <div class="skeleton-insight-group6">
      <div class="skeleton-insight-item01"></div>
      <div class="skeleton-insight-item02"></div>
      <div class="skeleton-insight-item02"></div>
      <div class="skeleton-insight-item02"></div>
      <div class="skeleton-insight-item02"></div>
    </div>
    <div class="skeleton-insight-group7">
      <div class="skeleton-insight-item01"></div>
    </div>
    <div class="skeleton-insight-group8">
      <div class="skeleton-insight-item01"></div>
      <div class="skeleton-insight-item01"></div>
      <div class="skeleton-insight-item02"></div>
      <div class="skeleton-insight-item03"></div>
      <div class="skeleton-insight-item03"></div>
    </div>
    <div class="skeleton-insight-group9">
      <div class="skeleton-insight-col">
        <div class="skeleton-insight-item01"></div>
        <div class="skeleton-insight-item02"></div>
        <div class="skeleton-insight-item03"></div>
      </div>
      <div class="skeleton-insight-col">
        <div class="skeleton-insight-item01"></div>
        <div class="skeleton-insight-item02"></div>
        <div class="skeleton-insight-item03"></div>
      </div>
      <div class="skeleton-insight-col">
        <div class="skeleton-insight-item01"></div>
        <div class="skeleton-insight-item02"></div>
        <div class="skeleton-insight-item03"></div>
      </div>
      <div class="skeleton-insight-col">
        <div class="skeleton-insight-item01"></div>
        <div class="skeleton-insight-item02"></div>
        <div class="skeleton-insight-item03"></div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`
export const getSkeletonHomeTmplSub1 = () =>`
<div class="component-skeleton-sub">
  <!--skeletonSource-->
  <span class="hide-txt">로딩중</span>
  <div class="skeleton-pubsub-group skeleton-animation-all" aria-hidden="true">
    <div class="skeleton-header">
      <div class="skeleton-btn-back">
        <i class="ico-back" aria-hidden="true"></i>
      </div>
    </div>
    <div class="skeleton-pubsub-my-act">
      <div class="skeleton-item-group1">
        <div class="skeleton-item"></div>
      </div>
      <div class="skeleton-item-group2">
        <div class="skeleton-item item01"></div>
        <div class="skeleton-item item02"></div>
        <div class="skeleton-item item03"></div>
        <div class="skeleton-item item04"></div>
      </div>
      <div class="skeleton-item-group3">
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
      </div>
      <div class="skeleton-item-group4">
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
      </div>
      <div class="skeleton-item-group3">
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
      </div>
      <div class="skeleton-item-group4">
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
        <div class="skeleton-item"></div>
      </div>
    </div>
  </div>
  <!--skeletonSource-->
</div>
`